import { NgModule } from '@angular/core';
import { MatCheckboxModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatRadioModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { ReusableHeaderBreadcrumbContainerModule, SharedModule } from "@app/shared";
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { CalendarModule } from 'primeng/calendar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TableModule } from 'primeng/table';
import { StopAndKnockAddEditComponent, StopAndKnockListComponent, StopAndKnockRemoveEquipmentComponent } from './';

const routes: Routes = [
  { path: 'add-edit', component: StopAndKnockAddEditComponent, data: { title: 'Stop and Knock Add Edit' }, canActivate: [AuthGuard] },
  { path: '', component: StopAndKnockListComponent, data: { title: 'Stop and Knock List' }, canActivate: [AuthGuard] },
  { path: 'add-edit/equipment-removal', component: StopAndKnockRemoveEquipmentComponent, data: { title: 'Stop and Knock Equipment Removal' }, canActivate: [AuthGuard] }
];
@NgModule({
  declarations: [StopAndKnockAddEditComponent, StopAndKnockListComponent, StopAndKnockRemoveEquipmentComponent],
  imports: [
    RouterModule.forChild(routes),
    SharedModule, CalendarModule, ScrollPanelModule, MatFormFieldModule, MatRadioModule,MatInputModule,
    TableModule, MatDatepickerModule, MatCheckboxModule,ReusableHeaderBreadcrumbContainerModule
  ]
})
export class StopAndKnockModule { }
